import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    getUsers(users) {
        axios.get(requesturl() + "/api/latest/user", {headers: {Authorization: window.$cookies.get("token")}})
            .then(res => {
                users(res.data);
                cookiemanager.updateCookies(res.headers);
            }).catch(error => {
            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
        });
    },

    async deleteUser(user, response) {
        await axios.delete(requesturl() + "/api/latest/user/" + user.userId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                cookiemanager.updateCookies(res.headers);
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };

                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }

                response(responseObj);
            });
    },

    async postUser(user, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/User',
            headers: headers,
            data: JSON.stringify(user)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    },

    async putUser(user, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/User/' + user.userId,
            headers: headers,
            data: JSON.stringify(user)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    },

    async setCurrentUserInformation(res) {

        await axios.get(requesturl() + "/api/latest/User/CurrentUser", {headers: {Authorization: window.$cookies.get("token")}})
            .then(result => {
                cookiemanager.updateCookies(result.headers);

                let currentUser = {
                    userId: result.data.userId,
                    username: result.data.userName,
                    firstname: result.data.firstName,
                    lastname: result.data.lastName
                };

                res(currentUser);
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async getCurrentUser(res) {

        await axios.get(requesturl() + "/api/latest/User/CurrentUser", {headers: {Authorization: window.$cookies.get("token")}})
            .then(result => {
                cookiemanager.updateCookies(result.headers);

                res(result.data);
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async updateCurrentUserRights() {
        await axios.get(requesturl() + "/api/latest/User/Rights", {headers: {Authorization: window.$cookies.get("token")}})
            .then(res => {
                window.$cookies.set("userRights", JSON.stringify(res.data), '120MIN');
            });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/userinterface.js